import { Component, OnInit } from '@angular/core';
import { ResetPasswordTokenComponent } from '../../components/reset-password-token/reset-password-token.component';

@Component({
    selector: 'reset-password-container',
    templateUrl: './reset-password-container.component.html',
    imports: [
        ResetPasswordTokenComponent
    ]
})

export class ResetPasswordContainerComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }
}